import * as ReactModal from "react-modal"

import PropTypes from "prop-types"

import styles from "./Modal.module.scss"

const Modal = ({
  children,
  isOpen,
  onAfterOpen,
  onRequestClose,
  contentLabel,
  large,
  hideHeaderAndClose = false,
}) => {

  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      className={[styles.modal, large ? styles.large : " "].join(" ")}
      overlayClassName={styles.overlay}
      contentLabel={contentLabel}
      parentSelector={() => document.querySelector("#root")}
      appElement={document.querySelector("#root")}
    >
      {!hideHeaderAndClose &&
        (contentLabel ? (
          <div className={styles.header}>
            <div className={styles.headerLeft}>{contentLabel}</div>
            {onRequestClose && (
              <button className={styles.close} onClick={onRequestClose}>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.43945 20.0611L20.5621 3.93848" stroke="white" strokeWidth="1.34355" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4.43945 3.93848L20.5621 20.0611" stroke="white" strokeWidth="1.34355" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          </div>
        ) : (
          onRequestClose && (
            <button className={styles.close} onClick={onRequestClose}>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.43945 20.0611L20.5621 3.93848" stroke="white" strokeWidth="1.34355" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.43945 3.93848L20.5621 20.0611" stroke="white" strokeWidth="1.34355" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )
        ))}
      {children}
    </ReactModal>
  )
}

export default Modal

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func,
  contentLabel: PropTypes.string,
  large: PropTypes.bool,
}

Modal.defaultProps = {
  children: null,
  isOpen: false,
  onAfterOpen: null,
  onRequestClose: null,
  contentLabel: "",
  large: false,
}
